// Babel  imports to be used with "useBuiltIns": "entry"
import "core-js/stable";
import "regenerator-runtime/runtime";

import App from './App.svelte';
import API from './api';
//import { Syncro } from './syncro'
//import { iDB, validateFeatures, Storages } from './libs'


// LOG AND DEBUG switches
window.DEBUG = {
  on: true,
  // Debug users 
  //user: 'tjara@mp-wines.com',
  //passw: 'demo',
  //user: 'cecilia.gonzalez@compass-group.com.ar',
  //passw: 'CGSUS0202',
  user: 'testadmin@treme.io',
  passw: 'admin',
}


// all required features are available ?
const featured = null; // validateFeatures();

/*
  For allowing modules bundled and transpiled to be called
  from the old code, we need to add them to the 'windows' 
  global scope:

    window.Module = Module;

  Or we may include them in the existent Appl namespace.

    window.Appl.Module = Module ;
*/
//if (featured) {

  window.Appl = window.Appl || {}; // just in case it is not declared

  const srv = API.remote('LOCAL')
  API.origin(srv.protocol, srv.host, srv.port, srv.code)
  window.API2 = API;

  // window.Appl.Syncro = Syncro;

  // window.Idb = iDB({
  //   name: 'grip',
  //   store: 'xstore',
  //   version: 1
  // });

  // Idb.open().then(() => {
  //   console.log("Idb opened");
  // })

  // window.Appl.Storages = Storages;
//}

const app = new App({
  target: document.body,
  props: {
    featured: featured // disable use if features not avail
  }
});

export default app;
